import React, { FC } from 'react';

import { Box } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import { CustomSpinner } from 'components/DataDisplay/Spinner/CustomSpinner';
import { selectActiveResource } from 'containers/ActiveCloudResource/selectors';

import { getSummary } from './getSummary';

export const CloudResourceOverview: FC = () => {
  const {
    cloudProvider,
    resourceType,
    resourceDetails,
    resourceInsight,
  } = useSelector(selectActiveResource);

  return resourceInsight.isLoading || resourceDetails.isLoading ? (
    <CustomSpinner
      loading={resourceInsight.isLoading || resourceDetails.isLoading}
      size="lg"
    />
  ) : (
    <Box h="full" overflow="auto">
      {getSummary(resourceType, cloudProvider!)}
    </Box>
  );
};
